import { render, staticRenderFns } from "./CustProductDetail.vue?vue&type=template&id=9fcd49de&scoped=true"
import script from "./CustProductDetail.vue?vue&type=script&lang=js"
export * from "./CustProductDetail.vue?vue&type=script&lang=js"
import style0 from "./CustProductDetail.vue?vue&type=style&index=0&id=9fcd49de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcd49de",
  null
  
)

export default component.exports